import CircleAnchor from '@editor/pages/projects/editor/objects/EditorCircleAnchor'
import { RootState } from '@editor/store/app'
import { useSelector } from 'react-redux'

import { AnchorsProps } from '../definitions'
import useAnchorEventHandlers from '../hooks/useAnchorEventHandlers'

const Anchors = (props: AnchorsProps) => {
  const { id, points, visible } = props

  // Hooks
  const { hoveredAnchor, mouseDownHandler, mouseEnterHandler, mouseLeaveHandler } = useAnchorEventHandlers(props)

  // Store
  const selectedElementIds = useSelector((state: RootState) => state.toolUtil.core.selectedElementIds)
  const hoveredElementId = useSelector((state: RootState) => state.toolUtil.core.hoveredElementId)
  const editingElementId = useSelector((state: RootState) => state.toolUtil.core.editingElementId)

  // Derived
  const isSelected = selectedElementIds.includes(id)
  const isHoverSelected = hoveredElementId === id || isSelected

  return (
    <>
      {points[0] && visible ? (
        <CircleAnchor
          id={`${id}-anchor-0`}
          point={points[0]}
          scale={0.8}
          visible
          outlineOpacity={isHoverSelected || hoveredAnchor === 0 ? 1 : 0}
          opacity={isHoverSelected || hoveredAnchor === 0 ? 1 : 0} // use opacity instead of visible to retain mouse events
          onDown={mouseDownHandler(0)}
          onEnter={editingElementId ? undefined : mouseEnterHandler(0)}
          onLeave={editingElementId ? undefined : mouseLeaveHandler}
        />
      ) : null}
      {points[1] && visible ? (
        <CircleAnchor
          id={`${id}-anchor-1`}
          point={points[1]}
          scale={0.8}
          visible
          outlineOpacity={isHoverSelected || hoveredAnchor === 1 ? 1 : 0}
          opacity={isHoverSelected || hoveredAnchor === 1 ? 1 : 0} // use opacity instead of visible to retain mouse events
          onDown={mouseDownHandler(1)}
          onEnter={editingElementId ? undefined : mouseEnterHandler(1)}
          onLeave={editingElementId ? undefined : mouseLeaveHandler}
        />
      ) : null}
    </>
  )
}

export default Anchors
